module.exports = __webpack_public_path__ + "static/joystream-dao-foreground-b5164eeade32db6b7aecbcb402a6e1d7.webp";